// 令牌
export const getToken = state => state.token

// 权限
export const getPermissions = state => state.permissions